<template>
  <modal :title="$t('business.carrier_detail')"
     :visible.sync="isShowDialog" width="1000px" @close="close">
    <!-- 总体信息的table -->
    <div class="border">
      <div class="bg-theme color-white"
       style="width: 100%;text-align:center; height:30px;line-height:30px;">
       {{ $t('public.total_info') }}
      </div>
      <div class="uk-flex">
        <div style="width: 60%">
          <BarEchart :chartData="setBarEchartData(totalList)"/>
        </div>
        <el-table
          :data="totalList"
          border
          show-summary
          :sum-text="$t('public.total')"
          style="width: 40%; float:left;">
          <el-table-column
            :label="$t('public.carrier_type')"
            width="180"
            >
            <template  slot-scope="scope">
              <span>{{ $t(carrierTypeConvert(scope.row.typeId).title) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="carrierNum"
            :label="$t('public.amount')"
          >
          </el-table-column>
          <el-table-column
            prop="carrierDeviceNum"
            :label="$t('public.installation_point_num')">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div v-for="(item, index) in detailList" :key="index" style="margin:20px 0;" class="border">
      <div class="bg-theme color-white"
       style="width: 100%;text-align:center; height:30px;line-height:30px;">
       {{ item.scene.name }}
      </div>
      <div class="uk-flex">
        <div style="width: 60%">
          <BarEchart v-if="item.data && item.data.length" :chartData="setBarEchartData(item.data)"/>
          <el-empty v-else :description="$t('public.no_data')"></el-empty>
        </div>
        <el-table
          :data="item.data"
          border
          show-summary
          :sum-text="$t('public.total')"
          style="width: 40%; float:left;">
          <el-table-column
            :label="$t('public.carrier_type')"
            width="180"
            >
            <template  slot-scope="scope">
              <span>{{ $t(carrierTypeConvert(scope.row.typeId).title) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="carrierNum"
            :label="$t('public.amount')"
          >
          </el-table-column>
          <el-table-column
            prop="carrierDeviceNum"
            :label="$t('public.installation_point_num')">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </modal>
</template>
<script>
import { getCarrierDetail } from '@/api/modules/overview.js'
import { sensorType, sensorTypeConvert } from '@/utils/dict/sensor'
import { deviceTypeConvert, deviceStatusConvert, carrierTypeConvert} from '@/utils/convert.js'
import BarEchart from '@/components/echart/barEchart.vue';


export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    sceneIds: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    }
  },
  components: {
    BarEchart,
  },
  data(){
    return {
      detailList: [],
      totalList: [], // 总的数据

      sensorTypeConvert,
      deviceTypeConvert,
      carrierTypeConvert
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    // 计算总数、在线等各种数量
    count(){
      let count = {
        total: 0,
        online: 0,
        offline: 0,
        stop: 0,
        unconfirm: 0
      }
      this.detailList.forEach(item => {
        item.data.forEach(d => {
          count.total = count.total + d.totalCount
          count.online = count.online + d.onLine
          count.offline = count.offline + d.offLine
          count.stop = count.stop + d.stopCount
          count.unconfirm = count.unconfirm + d.unknownCount
        })
      });
      return count
    },

  },
  created(){
    this.getDetail()
  },
  methods: {
    getDetail(){
      getCarrierDetail({ scenes: this.sceneIds.join() }).then(res => {
        if (res.state.code === 200) {
          this.detailList = res.result
          // 整理总数
          let totalArr = JSON.parse(JSON.stringify(this.detailList[0].data) )
          if(this.detailList.length > 1)
          for(let i=1; i<this.detailList.length; i++){
            this.detailList[i].data.forEach(item => {
              let index = totalArr.findIndex(_ => _.typeId === item.typeId)
              if(index !== -1){
                totalArr[index].carrierNum += item.carrierNum
                totalArr[index].carrierDeviceNum += item.carrierDeviceNum
              }else{
                totalArr.push(item)
              }
            })
          }
          this.totalList = totalArr
        }
      })
    },
    close(){
      this.$emit('close')
    },
    // 整理柱状图数据
    setBarEchartData(data){
      let barSeries = {
        xAxis: [],
        series: []
      }
      let arr1 = []
      let arr2 = []
      data.forEach(item => {
        barSeries.xAxis.push(this.$t(carrierTypeConvert(item.typeId).title))
        arr1.push(item.carrierNum)
        arr2.push(item.carrierDeviceNum)
      })
      barSeries.series.push(arr1)
      barSeries.series.push(arr2)
      return {
        barSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: '',
          name: ''
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.echarts {
  // width: 50% !important;
  height: 250px !important;
}
</style>
